<app-home-privacy-terms-header [header]="header"></app-home-privacy-terms-header>
<app-home-privacy-terms-body [contentTranslocoKey]="'home.terms.content'"></app-home-privacy-terms-body>
    